"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorResponse = void 0;
const tslib_1 = require("tslib");
const zod_1 = tslib_1.__importDefault(require("zod"));
const refine_1 = require("../util/refine");
const ErrorResponseSchema = zod_1.default.object({
    error: zod_1.default.string(),
});
exports.ErrorResponse = ErrorResponseSchema.refine((refine_1.is));
